import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { cloneDeep } from "lodash"

import { CONFIG_CURRENCY_BY_COUNTRY, CONFIG_CUTOFF_INTERVALS } from "./constants"
import { dropMinimumFeeUnlessMonthly, isMinimumFeeValid } from "./utils"
import MinimumFeeService from "./StoreBillingServices/MinimumFeeService"

const StoreBillingConfig = ({
    storeBillingConfiguration,
    onUpdateConfig,
    storeBillingServices,
    onUpdateStoreBillingServices,
    onIsValid,
    storeId,
    warehouse
}) => {
    const { i18n } = useTranslation()
    const [localConfig, setLocalConfig] = useState(storeBillingConfiguration)

    const handleOnChangeCutoffInterval = (newCutoffInterval) => {
        const localConfigCopy = cloneDeep(localConfig)
        localConfigCopy.cutoff_interval = newCutoffInterval
        setLocalConfig(localConfigCopy)

        const configCopy = cloneDeep(localConfigCopy)
        onUpdateConfig(configCopy)
    }

    useEffect(() => {
        const isCutoffIntervalValid = Object.values(CONFIG_CUTOFF_INTERVALS).some(cutoffInterval => cutoffInterval === localConfig.cutoff_interval)
        // A weekly configuration never keeps a minimum fee, so only a monthly one has to be valid.
        const isMinimumFeeSectionValid = isMinimumFeeValid(dropMinimumFeeUnlessMonthly(storeBillingServices || [], localConfig.cutoff_interval))
        onIsValid(isCutoffIntervalValid && isMinimumFeeSectionValid)
    }, [localConfig, storeBillingServices])

    return (
        <div>
            <div>
                <h2 className="text-xl text-gray-500"><span className="text-red-500">*</span>{i18n.t("billing.store_billing_config.cutoff_interval.title")}</h2>

                <div className="flex gap-4">
                    {Object.values(CONFIG_CUTOFF_INTERVALS).map(cutoffInterval => (
                        <label key={`cutoff-interval-${cutoffInterval}`}>
                            <input
                                type="radio"
                                value={cutoffInterval}
                                name={"config-intervals"}
                                onChange={(e) => handleOnChangeCutoffInterval(e.target.value)}
                                checked={cutoffInterval === localConfig.cutoff_interval}
                            />
                            {i18n.t(`billing.store_billing_config.cutoff_interval.options.${cutoffInterval}`)}
                        </label>
                    ))}
                </div>
            </div>

            {localConfig.cutoff_interval === CONFIG_CUTOFF_INTERVALS.INTERVAL_MONTHLY && (
                <MinimumFeeService
                    storeBillingServices={storeBillingServices}
                    onUpdateStoreBillingServices={onUpdateStoreBillingServices}
                    storeId={storeId}
                    warehouse={warehouse}
                    currency={storeBillingConfiguration.currency || CONFIG_CURRENCY_BY_COUNTRY[warehouse?.country]}
                />
            )}
        </div>
    )
}

export default StoreBillingConfig